import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Gift, Check, Clock, Footprints, BarChart3 } from 'lucide-react';
const bonuses = [{
  number: 1,
  icon: Clock,
  image: 'https://cdn.magicpatterns.com/uploads/mhQAhHCYejj9arvCt9yGiz/bono_1.png',
  title: 'Modo Día Malo — Rescate de 6 Minutos',
  description: 'Hay días en los que la rodilla amanece más rígida, sensible o "cargada". Y ahí es donde la mayoría se pierde: o fuerza de más… o se frena por completo. Este bono te da un protocolo ultra corto (con semáforo) para esos días, sin improvisar.',
  includes: ['Rescate guiado de 6 minutos (paso a paso)', 'Reglas claras para ajustar sin miedo', 'Checklist imprimible en 1 página'],
  whyItMatters: 'Porque el plan no se rompe cuando el día viene malo.'
}, {
  number: 2,
  icon: Footprints,
  image: 'https://cdn.magicpatterns.com/uploads/qLUZaWpvh698A3bZYBrRZg/bono_2.png',
  title: 'Caminata Inteligente — Guía Anti-Inflamación (Regla 2–1–2)',
  description: 'Si caminar se convirtió en "hoy salgo… mañana pago", esto te va a dar mucha tranquilidad. Este bono te enseña a caminar con un sistema simple de bloques + pausas para que sumes constancia sin castigar la rodilla.',
  includes: ['La regla 2–1–2 (caminar / pausa / caminar)', 'Semáforo aplicado a la caminata (qué hacer en verde/amarillo/rojo)', 'Checklist de salida + plan de 14 días imprimible'],
  whyItMatters: 'Porque caminar es vida diaria… y necesitás una forma de hacerlo sin recaer.'
}, {
  number: 3,
  icon: BarChart3,
  image: 'https://cdn.magicpatterns.com/uploads/8okgTEkkLvTmk6zApAbUtb/bono_3.png',
  title: 'Control de Progreso — Tracker + Tests (Día 1 / 7 / 14)',
  description: 'Una de las razones por las que la gente abandona es simple: no ve progreso claro… y siente que está "intentando a ciegas". Este bono te da un sistema muy fácil para medir avances reales en 2 minutos por día.',
  includes: ['Tests simples en Día 1 / Día 7 / Día 14', 'Registro diario (semáforo + nivel + cómo amanecés)', 'Hoja semanal imprimible + regla "2 días verdes para subir"'],
  whyItMatters: 'Porque cuando ves progreso, seguís. Y cuando seguís, ganás.'
}];
export function Bonuses() {
  return <Section background="light" data-id="element-33">
      <FadeIn data-id="element-34">
        {/* Section intro */}
        <div className="text-center mb-12" data-id="element-35">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#1B4332] mb-6" data-id="element-36">
            <Gift className="w-7 h-7 text-white" data-id="element-37" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-38">
            Y eso no es todo…
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed" data-id="element-39">
            Para que esto sea todavía más fácil de seguir (especialmente en días
            "difíciles")… al comprar Rodilla Sin Miedo, no te llevás solo el PDF
            principal.
          </p>
          <p className="text-lg font-medium text-[#1B4332] mt-4" data-id="element-40">
            Te llevás también 3 bonos descargables diseñados para que puedas
            mantener constancia, evitar recaídas y ver progreso real sin
            adivinar.
          </p>
        </div>

        {/* Value banner */}
        <div className="bg-[#1B4332] rounded-xl p-4 md:p-5 text-center mb-12" data-id="element-41">
          <p className="text-[#D8F3DC] text-sm font-semibold uppercase tracking-wider mb-1" data-id="element-42">
            Valor total de los bonos
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-43">
            <span className="text-2xl text-white/50 line-through font-medium" data-id="element-44">
              $47.000 ARS
            </span>
            <span className="text-3xl font-bold text-white" data-id="element-45">HOY: $0</span>
          </div>
          <p className="text-[#D8F3DC] text-sm mt-1" data-id="element-46">
            Incluidos gratis con tu compra
          </p>
        </div>
      </FadeIn>

      {/* Bonus cards */}
      <div className="space-y-10" data-id="element-47">
        {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-48">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-49">
              <div className="grid md:grid-cols-5 gap-0" data-id="element-50">
                {/* Image */}
                <div className="md:col-span-2 bg-gray-50 flex items-center justify-center p-6 md:p-8" data-id="element-51">
                  <img src={bonus.image} alt={bonus.title} className="w-full max-w-[240px] h-auto object-contain drop-shadow-lg" data-id="element-52" />
                </div>

                {/* Content */}
                <div className="md:col-span-3 p-6 md:p-8" data-id="element-53">
                  {/* Badge */}
                  <div className="flex items-center gap-3 mb-4" data-id="element-54">
                    <span className="inline-flex items-center gap-1.5 bg-[#D8F3DC] text-[#1B4332] text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-55">
                      <Check className="w-3.5 h-3.5" data-id="element-56" />
                      Bono #{bonus.number} — Gratis
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-bold text-[#111] mb-3 font-serif" data-id="element-57">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed mb-5" data-id="element-58">
                    {bonus.description}
                  </p>

                  {/* Includes */}
                  <div className="mb-5" data-id="element-59">
                    <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-60">
                      Incluye:
                    </p>
                    <ul className="space-y-2" data-id="element-61">
                      {bonus.includes.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-62">
                          <Check className="w-4 h-4 text-[#40916C] mt-0.5 flex-shrink-0" data-id="element-63" />
                          <span className="text-sm text-gray-700" data-id="element-64">{item}</span>
                        </li>)}
                    </ul>
                  </div>

                  {/* Why it matters */}
                  <div className="bg-[#FAFAF8] rounded-lg p-4 border-l-4 border-[#40916C]" data-id="element-65">
                    <p className="text-sm" data-id="element-66">
                      <span className="font-semibold text-[#1B4332]" data-id="element-67">
                        Por qué importa:{' '}
                      </span>
                      <span className="text-gray-600 italic" data-id="element-68">
                        {bonus.whyItMatters}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>

      {/* Summary + CTA */}
      <FadeIn delay={0.4} data-id="element-69">
        <div className="mt-14 bg-[#1B4332] rounded-2xl p-8 md:p-10 text-center text-white" data-id="element-70">
          <h3 className="text-2xl md:text-3xl font-bold font-serif mb-4" data-id="element-71">
            Rodilla Sin Miedo + 3 bonos gratis
          </h3>
          <p className="text-[#D8F3DC] text-lg leading-relaxed max-w-xl mx-auto mb-3" data-id="element-72">
            Sistema completo para:
          </p>
          <ul className="inline-flex flex-col items-start gap-2 mb-6 text-left" data-id="element-73">
            <li className="flex items-center gap-2.5 text-[#D8F3DC]" data-id="element-74">
              <Check className="w-5 h-5 flex-shrink-0" data-id="element-75" />
              <span data-id="element-76">Moverte con reglas (sin recaídas)</span>
            </li>
            <li className="flex items-center gap-2.5 text-[#D8F3DC]" data-id="element-77">
              <Check className="w-5 h-5 flex-shrink-0" data-id="element-78" />
              <span data-id="element-79">Sostener la constancia incluso en días malos</span>
            </li>
            <li className="flex items-center gap-2.5 text-[#D8F3DC]" data-id="element-80">
              <Check className="w-5 h-5 flex-shrink-0" data-id="element-81" />
              <span data-id="element-82">Tener claridad de avance real</span>
            </li>
          </ul>

          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-83">
            <span className="text-lg text-white/50 line-through" data-id="element-84">
              Bonos: $47.000 ARS
            </span>
            <span className="bg-white/10 text-white font-bold px-4 py-1.5 rounded-full text-sm" data-id="element-85">
              HOY GRATIS
            </span>
          </div>

          <Button size="lg" variant="outline" scrollTo="checkout" className="bg-white text-[#1B4332] border-white hover:bg-[#D8F3DC] hover:text-[#1B4332] font-bold" data-id="element-86">
            Asegurá tu acceso ahora
          </Button>
        </div>
      </FadeIn>
    </Section>;
}